import { Checkbox, DatePicker, Form, InputNumber, Select } from "antd";
import { FC } from "react";
import { capitalize } from "~/utils";
import { SubscriptionTier, SubscriptionStatus } from "~/utils/constants";

type Props = {};

export const TabAppControl: FC<Props> = () => {
  const form = Form.useFormInstance();
  const isSaasCustomer = Form.useWatch("isSaasCustomer", form);

  return (
    <div className="space-y-6">
      <div className="mb-4">
        <h2 className="text-lg font-semibold">App Control</h2>
        <p className="text-gray-500 text-sm">
          Manage SaaS subscription settings for this client
        </p>
      </div>

      {/* SaaS Customer Configuration */}
      <div className="p-4 border rounded-lg bg-purple-50 border-purple-200">
        <h3 className="font-medium mb-4 text-purple-800">SaaS Subscription</h3>
        <div className="space-y-4">
          <Form.Item name="isSaasCustomer" valuePropName="checked">
            <Checkbox>
              This client is a SaaS customer
            </Checkbox>
          </Form.Item>

          {isSaasCustomer && (
            <>
              <div className="grid grid-cols-2 gap-4">
                <Form.Item
                  name="subscriptionTier"
                  label="Subscription Tier"
                >
                  <Select placeholder="Select tier">
                    {Object.values(SubscriptionTier).map((tier) => (
                      <Select.Option key={tier} value={tier}>
                        {capitalize(tier)}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="subscriptionStatus"
                  label="Status"
                >
                  <Select placeholder="Select status">
                    {Object.values(SubscriptionStatus).map((status) => (
                      <Select.Option key={status} value={status}>
                        {capitalize(status)}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <Form.Item
                  name="subscriptionStartDate"
                  label="Start Date"
                >
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
                <Form.Item
                  name="subscriptionEndDate"
                  label="End Date"
                >
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </div>
              <Form.Item
                name="monthlyServiceSpend"
                label="Monthly Service Spend ($)"
                extra="Average monthly spend on art handling services"
              >
                <InputNumber
                  prefix="$"
                  min={0}
                  precision={2}
                  style={{ width: "100%" }}
                  placeholder="e.g., 1500.00"
                />
              </Form.Item>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
